import React, { useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  INTRANETHOSTNAME,
  REST_URLS,
} from "../../packages/common-utilities/utils/end-points";

const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();

  const validatePassword = (password) => {
    if (!password) {
      return "Password is required";
    }
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    const numberRegex = /[0-9]/;
    const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

    if (!numberRegex.test(password)) {
      return "Password must contain at least one number";
    }
    if (!specialCharRegex.test(password)) {
      return "Password must contain at least one special character";
    }

    return "";
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordError(validatePassword(value));
  };

  const resetPasswordHandler = () => {
    const error = validatePassword(password);
    setPasswordError(error);

    if (!error) {
      if (password !== confirmPassword) {
        toast.error("Password and confirm password do not match", {
          autoClose: 2000,
        });
        return;
      }

      invokeApi(
        HTTP_METHODS.POST,
        `${INTRANETHOSTNAME}${REST_URLS.RESET_PASSWORD}`,
        { password },
        { token: searchParams.get("token") }
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.info("Password Reset Successfully");
            setPassword("");
            setConfirmPassword("");
            navigate("/");
          }
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <div className="forgot-pass-con">
      <div className="content-con">
        <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center" }}>
          Reset Password
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "gray", textAlign: "center", mt: 1 }}
        >
          Create your new password
        </Typography>
        <Box
          sx={{
            width: { md: "70%", xs: "100%", sm: "100%" },
          }}
        >
          <TextField
            fullWidth
            label="Enter New Password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            error={!!passwordError}
            helperText={passwordError}
            margin="normal"
            placeholder="Password"
            size="small"
          />
          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            margin="normal"
            placeholder="Confirm Password"
            size="small"
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2 }}
            onClick={resetPasswordHandler}
          >
            Reset Password
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default ResetPassword;
